export default __webpack_public_path__ + "static/media/Papo-Seco.8a131dbd.jpg";